import CoreNumericInputComponent from './CoreNumericInputComponent';

class CoreCurrencyInputComponent extends CoreNumericInputComponent {

}


CoreCurrencyInputComponent.defaultProps = {
  ...CoreNumericInputComponent.defaultProps,
  prefix: '€ ',
  decimals: 2,
};

export default CoreCurrencyInputComponent;
